export default {
  title: 'Exklusive Angebote',
  header: {
    back: 'Zurück',
    title: 'Belohnungen',
  },
  info: {
    title: 'Sie haben {{points}} Punkte.',
    description:
      'Geben Sie {{amount}} aus, um 5 Punkte zu erhalten! Fügen Sie Artikel zu Ihrem Warenkorb hinzu, um sie mit Ihren verdienten Punkten kostenlos zu erhalten.',
  },
  rewards: {
    data: [
      {
        title: 'Verdienen Sie Punkte bei jeder Bestellung',
        description: 'Jeder {{amount}}, den Sie ausgeben, fügt 5 Punkte auf Ihr Konto hinzu.',
      },
      {
        title: 'Verdienen Sie Punkte bei jeder Bestellung',
        description:
          'Lösen Sie Ihre Punkte für kostenlose Goodies ein! Beginnen Sie mit dem Sammeln von Punkten bei 350 Punkten, was einem Einkauf von {{amount}} entspricht.',
      },
      {
        title: 'Verdienen Sie Punkte bei jeder Bestellung',
        description:
          'Entdecken Sie exklusive Angebote, Aktionen und Rabatte. Schauen Sie sich Mitgliederaktionen in der App an.',
      },
    ],
  },
};
